import Vue from "vue"
import { Mutations, Actions } from "./types"
import { MasterState, IMutations, IActions } from "./masterType"

function _init() {
  return {
    appAffiliateTemplates: [],
    bannerTypes: [],
  }
}

const state = _init()

const mutations: Mutations<MasterState, IMutations> = {
  initMaster(_state) {
    const newState = _init()
    Object.entries(newState).forEach(([k, v]) => {
      Vue.set(_state, k, v)
    })
  },
  updateAppAffiliateTemplates(_state, payload) {
    payload.forEach((appAffiliateTemplate) => {
      _state.appAffiliateTemplates.push(appAffiliateTemplate)
    })
  },
  updateBannerTypes(_state, payload) {
    payload.forEach((bannerType) => {
      _state.bannerTypes.push(bannerType)
    })
  },
}
const actions: Actions<MasterState, IActions, any, IMutations, any, any> = {
  updateAppAffiliateTemplates(context, payload) {
    context.commit("updateAppAffiliateTemplates", payload)
  },
  updateBannerTypes(context, payload) {
    context.commit("updateBannerTypes", payload)
  },
}

export const master = {
  namespaced: true,
  state,
  mutations,
  actions,
}
